import axios from 'axios'

axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.xsrfCookieName = 'csrftoken'

class Client {

  constructor () {
  }

  get (url, params) {
    var command = axios.get(url, {
      params: params,
      withCredentials: true
    })
    return command
  }

  post (url, data, params) {
    var command = axios.post(url, data, {
      params: params,
      withCredentials: true
    })
    return command
  }

}

export default new Client()
